<div class="row">
  <div class="col-md-12">
    <h1>
      <span>Početna > Jezici</span></h1>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <yt-fw-default-list-modal [CondensedTable]="true" #defaultList></yt-fw-default-list-modal>
  </div>
</div>